import ArticleVoiceItemType from "./ArticleVoiceItemType"
import ImageItem from "../../atoms/ImageItem/ImageItem";
import ArticleTitle from "../../atoms/ArticleTitle/ArticleTitle";
import IconNewSvg from "../../atoms/IconNew/IconNew";

import styles from "./ArticleVoiceItem.module.scss";
import ArticleDate from "../../atoms/ArticleDate/ArticleDate";
import ArticleAtribute from "../../atoms/ArticleAtribute/ArticleAtribute";

const ArticleVoiceItem = (props: ArticleVoiceItemType) => {
  const {id, imageItem,articleDate,articleTitle,iconNew,url,commonClass, name, area} = props;
  return (
    <div id={id} className={`${styles.ArticleVoiceItem}`}>
      <a href={url} className={styles.ArticleVoiceItem__inner}>
        <div className={styles.ArticleVoiceItem__img}>
          <ImageItem 
            id={imageItem.id}
            imgPCPath={imageItem.imgPCPath}
            imgSPPath={imageItem.imgSPPath}
            webpPCPath={imageItem.webpPCPath}
            webpSPPath={imageItem.webpSPPath}
            widthPC={imageItem.widthPC}
            heightPC={imageItem.heightPC}
            widthSP={imageItem.widthSP}
            heightSP={imageItem.heightSP}
            altText={imageItem.altText}
            commonClass={imageItem.commonClass}
            />
          {/* <div className={styles.iconNew}>
            <IconNewSvg
              id={iconNew.id}
              text={iconNew.text}
            />
          </div> */}
        </div>
        <div className={styles.ArticleVoiceItem__titleWrapper}>
          <div className={styles.articleDate}>
            <ArticleDate 
              // id={articleDate.id}
              date={articleDate.date}
              commonClass={articleDate.commonClass}
            />
          </div>
          <div className={styles.articleTitle}>
            <ArticleTitle 
              // id={articleTitle.id}
              text={articleTitle.text}
              commonClass={articleTitle.commonClass}
            />
          </div>
          <div>
            <ArticleAtribute
              text={name}
            />
            <ArticleAtribute
              text={area}
            />
          </div>
        </div>
      </a>
    </div>
  )
}

export default ArticleVoiceItem